import { Box, CircularProgress } from '@mui/material';
import React from 'react';

// Define prop types for styles
interface LoadingProps {
	style?: React.CSSProperties;
}

const Loading: React.FC<LoadingProps> = ({ style }) => {
	const defaultStyles: React.CSSProperties = {
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	};

	return (
		<Box
			sx={{
				...defaultStyles,
				...style,
			}}
		>
			<div className="chat__body__loadingMore__wrapper">
				<CircularProgress size={28} />
			</div>
		</Box>
	);
};

export default Loading;
